import type { ReactNode } from 'react';
import { AgxDivider } from '@urbanx/agx.ui-components2';

export const addHorizontalDividersBetweenElements = (elements: ReactNode[]) => {
  if (elements.length <= 1) return elements;

  return elements.flatMap((element, index) => {
    if (index === elements.length - 1) return element;

    return [element, <AgxDivider key={`divider-${index}`} variant="horizontal" />];
  });
};
